export default class Product {

  /**
  ** 実行
  ** @constructor
  **/      
  constructor () {
    this.getParam()
    this.init()
  }


  /**
  ** 各種要素を取得している
  ** @getParam
  ** 
  **/    
  getParam() {
    this.container = document.querySelector(`[data-module="product"]`)
    this.textChunkContainer = this.container.querySelector(`[data-module="text-chunk"]`)

    this.detailTextChunk = this.textChunkContainer.querySelector(`[data-module="detail-text"] > .text`)
    this.detailText = this.textChunkContainer.querySelector(`[data-module="detail-text"]`) 

    this.viewTextChunk = this.textChunkContainer.querySelector(`[data-module="view-text"] > .text`)
    this.viewText = this.textChunkContainer.querySelector(`[data-module="view-text"]`)

    this.prefaceTextChunk = this.textChunkContainer.querySelector(`[data-module="preface-text"] > p`)
    this.prefaceText = this.textChunkContainer.querySelector(`[data-module="preface-text"]`)

    this.tableContentTextChunk = this.textChunkContainer.querySelector(`[data-module="tablecontent-text"] > p`)
    this.tableContentText = this.textChunkContainer.querySelector(`[data-module="tablecontent-text"]`)
    this.chunkNum = [100,120,30,100] // ここで文字数制限をしています。
    this.commonBtn = '<span class="more-btn">もっと見る</span>'
    this.toggleCLass = 'is-show',
    this.closeTxt = '閉じる'
    this.openTxt = 'もっと見る'    
  }


  /**
  ** オブジェクトを初期化
  ** @init
  **/     
  init() {
    this.detailtextCut()
    this.viewtextCut()
    this.prefacetextCut()
    this.tablecontenttextCut()
  }


  /**
  ** 商品部分テキスト処理
  ** @detailtextCut
  **/

  detailtextCut() {
    const
      trueText = this.detailTextChunk.innerText,
      cutText = trueText.substr(0,this.chunkNum[0])


    const nl2br = (str)=> {
      return str.replace(/\n/g, '<br>')
    }


    this.detailTextChunk.innerHTML = nl2br(cutText)
    this.detailText.insertAdjacentHTML('beforeend',this.commonBtn)

    const clickEvent = () => {
      const
        moreBtn = this.detailText.querySelector('.more-btn')

      moreBtn.addEventListener('click', () => {
      
        if(moreBtn.classList.contains(this.toggleCLass)) {
          moreBtn.classList.remove(this.toggleCLass)
          this.detailTextChunk.innerHTML = nl2br(cutText)
          moreBtn.innerText = this.openTxt
        } else {
          moreBtn.classList.add(this.toggleCLass)
          this.detailTextChunk.innerHTML = nl2br(trueText)
          moreBtn.innerText = this.closeTxt
        }
      })
    }
    clickEvent()
  }




  /**
  ** 概要部分テキスト処理
  ** @viewtextCut
  **/ 

  viewtextCut() {
    const
      trueText = this.viewTextChunk.innerText,
      cutText = trueText.substr(0,this.chunkNum[0])


    const nl2br = (str)=> {
      return str.replace(/\n/g, '<br>')
    }


    this.viewTextChunk.innerHTML = nl2br(cutText)
    this.viewText.insertAdjacentHTML('beforeend',this.commonBtn)

    const clickEvent = () => {
      const
        moreBtn = this.viewText.querySelector('.more-btn')

      moreBtn.addEventListener('click', () => {
      
        if(moreBtn.classList.contains(this.toggleCLass)) {
          moreBtn.classList.remove(this.toggleCLass)
          this.viewTextChunk.innerHTML = nl2br(cutText)
          moreBtn.innerText = this.openTxt
        } else {
          moreBtn.classList.add(this.toggleCLass)
          this.viewTextChunk.innerHTML = nl2br(trueText)
          moreBtn.innerText = this.closeTxt
        }
      })
    }
    clickEvent()
  }


  /**
  ** 序文テキスト処理
  ** @prefacetextCut
  **/ 

  prefacetextCut() {
    const
      trueText = this.prefaceTextChunk.innerText,
      cutText = trueText.substr(0,this.chunkNum[0])


    const nl2br = (str)=> {
      return str.replace(/\n/g, '<br>')
    }


    this.prefaceTextChunk.innerHTML = nl2br(cutText)
    this.prefaceText.insertAdjacentHTML('beforeend',this.commonBtn)

    const clickEvent = () => {
      const
        moreBtn = this.prefaceText.querySelector('.more-btn')

      moreBtn.addEventListener('click', () => {
      
        if(moreBtn.classList.contains(this.toggleCLass)) {
          moreBtn.classList.remove(this.toggleCLass)
          this.prefaceTextChunk.innerHTML = nl2br(cutText)
          moreBtn.innerText = this.openTxt
        } else {
          moreBtn.classList.add(this.toggleCLass)
          this.prefaceTextChunk.innerHTML = nl2br(trueText)
          moreBtn.innerText = this.closeTxt
        }
      })
    }
    clickEvent()
  }



  /**
  ** 目次テキスト処理
  ** @tablecontenttextCut
  **/ 

 tablecontenttextCut() {
  const
    trueText = this.tableContentTextChunk.innerText,
    cutText = trueText.substr(0,this.chunkNum[0])


  const nl2br = (str)=> {
    return str.replace(/\n/g, '<br>')
  }


  this.tableContentTextChunk.innerHTML = nl2br(cutText)
  this.tableContentText.insertAdjacentHTML('beforeend',this.commonBtn)

  const clickEvent = () => {
    const
      moreBtn = this.tableContentText.querySelector('.more-btn')

    moreBtn.addEventListener('click', () => {
    
      if(moreBtn.classList.contains(this.toggleCLass)) {
        moreBtn.classList.remove(this.toggleCLass)
        this.tableContentTextChunk.innerHTML = nl2br(cutText)
        moreBtn.innerText = this.openTxt
      } else {
        moreBtn.classList.add(this.toggleCLass)
        this.tableContentTextChunk.innerHTML = nl2br(trueText)
        moreBtn.innerText = this.closeTxt
      }
    })
  }
  clickEvent()   
 }
   
}